export const CUSTOM_GRADE_COLOR = 'color-1';
export const CUSTOM_GRADE_BRILLIANCE = 'bril-1';
export const CUSTOM_GRADE_CUT_PERFORMANCE = 'cutperf-1';
export const CUSTOM_GRADE_FIRE = 'fire-1';
export const CUSTOM_GRADE_OPTICAL_SYMMETRY = 'osym-1';
export const CUSTOM_GRADE_BRILLIANCE_MARQUISE = 'bril-marquise-1';
export const CUSTOM_GRADE_FIRE_CUSHION = 'fire-cushion-1';
export const CUSTOM_GRADE_FLUORESCENCE = 'fluor-1';
export const CUSTOM_GRADE_GIRDLE_BEAUTY = 'gb-1';
